import { createFileRoute } from "@tanstack/react-router";
import BookMeetingPage from "@/pages/BookMeetingPage";

export const Route = createFileRoute("/book/$token")({
  component: BookMeetingPage,
});
